<template>
  <div id="violation_contract">
    <h5 class="headline">{{ $t("contract.violation.headline") }}</h5>
    <p class="user-output">
      {{ $t("contract.violation.paragraphOne", { amount }) }}
    </p>
    <p>{{ $t("contract.violation.paragraphTwo") }}</p>
    <p>{{ $t("contract.violation.paragraphThree") }}</p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    violation() {
      return this.$store.state.contract.violation;
    },
    amount() {
      let amount = this.violation.amount.replace(/\./g, "").replace(/,/g, ".");
      if (isNaN(amount)) {
        return "!IKKE ET TAL!";
      }

      if (amount !== "") {
        let amountParsed = Intl.NumberFormat(this.$i18n.locale()).format(
          amount
        );
        return amountParsed;
      }
      return this.$t("contract.violation.placeholder.amount");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/contract/Violation.vue